import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import { Utils } from 'src/app/common/services/utils.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';


@Component({
  selector: 'app-dataprivacy',
  templateUrl: './dataprivacy.component.html',
  styleUrls: ['./dataprivacy.component.css']
})
export class DataprivacyComponent implements OnInit {

  constructor(private router: Router,
    private utils: Utils,
    public ref: DynamicDialogRef,
    private httpService: HttpRequestService,
    private confirmationService: ConfirmationService) { }

  dashboardItems: any;
  showInfoMsg = false;

  privacyConfigForm: FormGroup = new FormGroup({
    strPdoPrivacy: new FormControl(true, Validators.required),
    strDataPrivacy: new FormControl(true, Validators.required)
  });

  onSubmit() {

    let formValues = this.privacyConfigForm.value

    if ((formValues.strPdoPrivacy == false) || (formValues.strDataPrivacy == false)) {
      this.confirmationService.confirm({
        message: 'Kindly select both the check box',
        header: 'Alert !',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'OK',
        rejectVisible: false,
      });
    }
    else {
      const requestData = this.utils.constructRequestData(formValues, 'DataPrivacyController', 'dataPrivacyCheck');

      this.httpService.configRequestDataWithHeaders(requestData, 'post', '').subscribe(
        (response: any) => {
          if (response && response.strFailureMsg == null) {
            this.ref.close(response)
          }
        });
    }
  }

  ngOnInit() {
    this.showInfoMsg = true;
  }

}
